import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, Cell } from "recharts";

const PRIORITY_COLORS = {
  emergency: "#FF3838", medical: "#00D2FF", public_safety: "#FF8A00",
  premium: "#FACC15", standard: "#E4E4E7", background: "#71717A",
};

export default function OperatorRevenue() {
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    api.get("/analytics/overview").then(({ data }) => setOverview(data));
  }, []);

  if (!overview) return <div className="p-8 text-zinc-500 font-mono text-xs">LOADING…</div>;

  const priorityData = Object.entries(overview.priority_breakdown).map(([k, v]) => ({ name: k, count: v }));

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">FINANCE</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Revenue & Usage</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <KPI label="Total kWh" value={overview.total_kwh_dispensed} color="#00E5FF" />
        <KPI label="Revenue" value={`$${overview.total_revenue_usd.toFixed(2)}`} color="#4ADE80" />
        <KPI label="Active" value={overview.active_sessions} color="#FACC15" />
        <KPI label="Online" value={`${overview.stations_online}/${overview.stations_total}`} color="#FFA800" />
      </div>

      <div className="bin-card p-6 mb-4">
        <div className="bin-label mb-4">DEMAND CURVE · LAST 24H · KWH/HR</div>
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={overview.hourly_kwh}>
            <CartesianGrid strokeDasharray="2 4" stroke="#27272A" />
            <XAxis dataKey="hour" tick={{ fill: "#71717A", fontSize: 10, fontFamily: "IBM Plex Mono" }} />
            <YAxis tick={{ fill: "#71717A", fontSize: 10, fontFamily: "IBM Plex Mono" }} />
            <Tooltip contentStyle={{ background: "#0F0F11", border: "1px solid #27272A", borderRadius: 4, fontFamily: "IBM Plex Mono", fontSize: 12 }} />
            <Line type="monotone" dataKey="kwh" stroke="#00E5FF" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="bin-card p-6">
        <div className="bin-label mb-4">PRIORITY MIX · ALL SESSIONS</div>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={priorityData}>
            <CartesianGrid strokeDasharray="2 4" stroke="#27272A" />
            <XAxis dataKey="name" tick={{ fill: "#71717A", fontSize: 10, fontFamily: "IBM Plex Mono" }} />
            <YAxis tick={{ fill: "#71717A", fontSize: 10, fontFamily: "IBM Plex Mono" }} />
            <Tooltip contentStyle={{ background: "#0F0F11", border: "1px solid #27272A", borderRadius: 4 }} />
            <Bar dataKey="count">
              {priorityData.map((p, i) => (
                <Cell key={i} fill={PRIORITY_COLORS[p.name] || "#71717A"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function KPI({ label, value, color }) {
  return (
    <div className="bin-card p-4">
      <div className="bin-label">{label}</div>
      <div className="text-2xl font-black font-mono mt-1" style={{ color }}>{value}</div>
    </div>
  );
}
